<template lang="html">

    <section class="wrapper wrapper-view -home-empresa">

        <div class="container texto-intro" v-if="!isLogged">
            <p><strong>BIENVENIDO AL PORTAL DE LA UNIVERSIDAD FRANCISCO DE VITORIA PARA EMPRESAS, INSTITUCIONES Y PROFESIONALES RECLUTADORES.</strong></p>

            <p>Más de 3.000 empresas desde 1996 encuentran a los candidatos mejor formados.</p>
            <p>El Departamento de Carreras Profesionales de la Universidad Francisco de Vitoria está a su disposición para ayudarle, apoyarle y hacer el seguimiento de sus procesos de selección.</p>
            <div class="to-login-buttons row-between ais">
                <div>
                    <p><strong>Si ya es usuario, por favor identifíquese.</strong></p>
                    <router-link class="btn" :to="$t('enlaces.login')+'/empresas'">Entrar</router-link>
                </div>
                <div>
                    <p><strong>Si todavía no es usuario, cree aquí su perfil.</strong></p>
                    <router-link class="btn -skull" :to="$t('enlaces.nuevaempresa')">Registrarme</router-link>
                </div>
            </div>
        </div>

        <div class="container options-container row-start -practicas ais" v-if="isLogged">

            <h1>Prácticas <span>(Estudiantes)</span></h1>

            <article class="option-wrapper">

                <div class="option-el">
                    <span class="bubble" v-if="isLogged">+</span>
                    <h2>Publicar</h2>
                    <h3>Nueva oferta de prácticas</h3>
                    <p>Publica ofertas de prácticas, dirigidas a nuestros alumnos.</p>
                    <router-link :to="$t('enlaces.nuevaoferta')+'/practicas'" class="enlace-cover"></router-link>
                </div>

            </article>

            <article class="option-wrapper">

                <div class="option-el">
                    <span class="bubble" v-if="isLogged" :loading="loading">{{ofertasvalues.numProcesosActivosPracticas}}</span>
                    <h2>Ofertas</h2>
                    <h3>De prácticas</h3>
                    <p>Consulta y gestiona las ofertas de prácticas y las candidaturas recibidas.</p>
                    <router-link :to="$t('enlaces.misofertas')+'/practicas'" class="enlace-cover"></router-link>
                </div>

            </article>

            <article class="option-wrapper">

                <div class="option-el">
                    <span class="bubble" v-if="isLogged" :loading="loading">{{ofertasvalues.numCandidatosPracticas}}</span>
                    <h2>Listado</h2>
                    <h3>Candidatos</h3>
                    <p>Consulta y gestiona las candidaturas recibidas.</p>
                    <router-link :to="$t('enlaces.candidatos')+'/practicas'" class="enlace-cover"></router-link>
                </div>

            </article>

            <article class="option-wrapper">

                <div class="option-el">
                    <span class="bubble -firma" v-if="isLogged"></span>
                    <h2>Empresa</h2>
                    <h3>Documentos firmados</h3>
                    <router-link :to="$t('enlaces.miperfil')+'/documentos-firmados'" class="enlace-cover"></router-link>
                </div>

            </article>

        </div>

        <div class="container options-container row-start -empleo ais" v-if="isLogged">

            <h1>Empleo <span>(Antiguos alumnos titulados)</span></h1>

            <article class="option-wrapper">

                <div class="option-el">
                    <span class="bubble" v-if="isLogged">+</span>
                    <h2>Publicar</h2>
                    <h3>Nueva oferta de empleo</h3>
                    <p>Publica ofertas de empleo, dirigidas a nuestros antiguos alumnos.</p>
                    <router-link :to="$t('enlaces.nuevaoferta')+'/empleo'" class="enlace-cover"></router-link>
                </div>

            </article>

            <article class="option-wrapper">

                <div class="option-el">
                    <span class="bubble" v-if="isLogged" :loading="loading">{{ofertasvalues.numProcesosActivosEmpleo}}</span>
                    <h2>Ofertas</h2>
                    <h3>De empleo</h3>
                    <p>Consulta y gestiona las ofertas de empleo y las candidaturas recibidas.</p>
                    <router-link :to="$t('enlaces.misofertas')+'/empleo'" class="enlace-cover"></router-link>

                </div>

            </article>

            <article class="option-wrapper">

                <div class="option-el">
                    <span class="bubble" v-if="isLogged" :loading="loading">{{ofertasvalues.numCandidatosEmpleo}}</span>
                    <h2>Listado</h2>
                    <h3>Candidatos</h3>
                    <p>Consulta y gestiona las candidaturas recibidas.</p>
                    <router-link :to="$t('enlaces.candidatos')+'/empleo'" class="enlace-cover"></router-link>

                </div>

            </article>

            <article class="option-wrapper">

                <div class="option-el">
                    <span v-if="isLogged" class="bubble -busqueda"></span>
                    <h2>Búsqueda</h2>
                    <h3>A la carta</h3>
                    <p>Defina su candidato ideal a la carta. </p>
                    <router-link :to="$t('enlaces.busquedaCarta')" class="enlace-cover"></router-link>
                </div>

            </article>

        </div>


        <!-- <div class="contenedor-banner container" v-if="banner.urlImagen">
            <h3 class="subtitle-section" v-if="!!banner.titulo">{{banner.titulo}}</h3>
            <a :href="banner.enlace" target="_blank">
                <img :src="banner.urlImagen" alt="">
            </a>
        </div> -->

  

    </section>

</template>

<script lang="js">
      
    import {mapGetters, mapActions} from 'vuex';
  
    export default {
      name: 'home-empresa',
      mounted(){
        if(this.isLogged){
            this.loading = true;
            this.requestNumeroProcesos().then(r => {
                this.loading = false;
                this.ofertasvalues = r;
            });
        }

        if(!!!this.testimonios){
          this.requestTestimonios('empresa');
        }

        if(!!!this.banner){
            this.requestBannerHome().then(r => {
                this.banner = r;
            });
        }

      },
      data(){
          return{
              ofertasvalues : '',
              loading : false,
              banner : ''
          }
      },
      computed : {
          ...mapGetters({
              isLogged : 'getLogged',
              testimonios : 'getTestimonios',
            })
      },
      methods : {
          ...mapActions(['requestNumeroProcesos','requestTestimonios','requestBannerHome'])
      }
    }
  </script>
<style scoped lang="scss">
  </style>


// WEBPACK FOOTER //
// src/components/view-parts/home/home-empresa.vue